import { ajax } from 'rxjs/ajax';

import env from 'config/env';

const { CONTENT_API_BASE_URL } = env;

export default function getGlobalSettings$({ locale = 'en' }) {
	return ajax.getJSON(`${CONTENT_API_BASE_URL}/${locale}/globalsettings`);
}
